const LocationsSection = () => {
  const locations = [
    {
      id: 1,
      name: 'Original Location',
      address: 'Calle Ignacio Mejía 4567, Centro, Ciudad Juárez',
      phone: '(656) 612-3456',
      hours: 'Mon-Sun: 10am-8pm',
      image: 'https://public.readdy.ai/ai/img_res/dcd1ce7390c96d34ea95e1334b022a40.jpg',
      features: ['Slow-Cooked Carnitas', 'Takeout Available', 'Weekend Specials']
    }
  ];

  return (
    <div>
      <div className="text-center mb-12">
        <h2 className="text-4xl font-bold text-zinc-900 mb-4">Our Location</h2>
        <p className="text-lg text-zinc-600">Visit us for the best carnitas in Ciudad Juárez</p>
      </div>

      <div className="space-y-8">
        {locations.map((location) => (
          <div
            key={location.id}
            className="bg-white border border-zinc-200 rounded-2xl overflow-hidden hover:shadow-xl transition-all duration-300"
          >
            <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
              <div className="lg:col-span-2">
                <div className="w-full h-full min-h-[300px]">
                  <img
                    src={location.image}
                    alt={location.name}
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>

              <div className="lg:col-span-3 p-8">
                <h3 className="text-2xl font-bold text-zinc-900 mb-4">{location.name}</h3>
                
                <div className="space-y-4 mb-6">
                  <div className="flex items-start gap-3">
                    <i className="ri-map-pin-line text-xl text-orange-600 mt-1"></i>
                    <div>
                      <p className="text-zinc-700 font-medium">Address</p>
                      <p className="text-zinc-600">{location.address}</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <i className="ri-phone-line text-xl text-orange-600 mt-1"></i>
                    <div>
                      <p className="text-zinc-700 font-medium">Phone</p>
                      <a href={`tel:${location.phone.replace(/[^0-9]/g, '')}`} className="text-zinc-600 hover:text-orange-600 transition-colors">
                        {location.phone}
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start gap-3">
                    <i className="ri-time-line text-xl text-orange-600 mt-1"></i>
                    <div>
                      <p className="text-zinc-700 font-medium">Hours</p>
                      <p className="text-zinc-600">{location.hours}</p>
                    </div>
                  </div>
                </div>

                <div className="mb-6">
                  <p className="text-zinc-700 font-medium mb-3">Features</p>
                  <div className="flex flex-wrap gap-2">
                    {location.features.map((feature, index) => (
                      <span
                        key={index}
                        className="px-3 py-1 bg-orange-50 text-orange-600 rounded-full text-sm font-medium"
                      >
                        {feature}
                      </span>
                    ))}
                  </div>
                </div>

                <div className="flex flex-wrap gap-3">
                  <a
                    href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(location.address)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 bg-orange-600 text-white px-6 py-3 rounded-full font-semibold hover:bg-orange-700 transition-colors whitespace-nowrap"
                  >
                    <i className="ri-map-line text-lg"></i>
                    Get Directions
                  </a>
                  <a
                    href={`tel:${location.phone.replace(/[^0-9]/g, '')}`}
                    className="inline-flex items-center gap-2 bg-zinc-100 text-zinc-900 px-6 py-3 rounded-full font-semibold hover:bg-zinc-200 transition-colors whitespace-nowrap"
                  >
                    <i className="ri-phone-line text-lg"></i>
                    Call Now
                  </a>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LocationsSection;
